import { useState, useRef, useEffect } from "react";
import style from "./PotSwipe.module.scss";
import { v4 } from "uuid";

import PotViewItem from "./PotViewItem";

const PotSwipe = ({ potIndex, pots, set_potIndex,onClick,type}) => {
    const timer = useRef(null);
    const containerRef = useRef(null);
    const [currentIndex, setCurrentIndex] = useState(potIndex);
    const [itemWidth, setItemWidth] = useState(0);
    useEffect(() => {
    }, []);

    useEffect(() => {
        if (containerRef.current) {
            const firstItem = containerRef.current.firstChild;
            if (firstItem) {
                setItemWidth(firstItem.getBoundingClientRect().width);
            }
        }
    }, [containerRef]);

    useEffect(() => {
        if (containerRef.current && itemWidth > 0) {
            containerRef.current.scrollLeft = itemWidth * potIndex;
        }
    }, [potIndex, itemWidth]);

    const handleScroll = (event) => {
        clearTimeout(timer.current);
        timer.current = setTimeout(() => {
            const scrollLeft = event.target.scrollLeft;
            const newIndex = Math.round(scrollLeft / itemWidth);
            setCurrentIndex(newIndex);
            set_potIndex(newIndex);
        }, 300);
    };

    return (
        <div className={style.app} onScroll={handleScroll} ref={containerRef}>
            {pots.map((v, k) => (
                <PotViewItem type={type} key={k} pot={v} onClick={data=>{onClick(data)}} />
            ))}
        </div>
    );
}

export default PotSwipe;
